import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React__default from 'react';
import { useInView } from '../node_modules/.pnpm/react-intersection-observer@9.4.0_react@18.2.0/node_modules/react-intersection-observer/react-intersection-observer.modern.mjs.js';
var IntersectionObserverStateContext = React__default.createContext(undefined);

function IntersectionObserverProvider(_ref) {
  var children = _ref.children;

  var _useInView = useInView({
    threshold: 0
  }),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1]; // NOTE: you *might* need to memoize this value
  // Learn more in http://kcd.im/optimize-context


  var value = {
    elementObservedRef: ref,
    isInView: inView
  };
  return React__default.createElement(IntersectionObserverStateContext.Provider, {
    value: value
  }, children);
}

function useIntersectionObserver() {
  var context = React__default.useContext(IntersectionObserverStateContext);

  if (context === undefined) {
    throw new Error('useIntersectionObserver must be used within a IntersectionObserverProvider');
  }

  return context;
}

export { IntersectionObserverProvider, useIntersectionObserver };